import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {editTag, fetchTagById} from "../../store/tag-slice";
import {tagSchema} from "../../schema/tagSchema";
import {getFormData} from "../../models/tagModel";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {getValidatedLimit} from "../../components/Utility";
import {Scope} from "../../enums/enums";

const TagEdit = () => {
    const params = useParams();
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.tag);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items,
        editStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.tag);

    const userRole = useSelector((state) => state.auth.selectedRole);

    useEffect(() => {
        dispatch(fetchTagById({...userRole, id: params.tagId}));
    }, [dispatch, params.tagId, userRole]);

    const tags = items.find(item => item.id === params.tagId);

    useEffect(() => {
        if (editStatus === "success") {
            navigator(`../../?page=${currentPage}&limit=${limit}`);
        }
    }, [editStatus, dispatch, navigator, currentPage, limit]);

    const formSubmitHandler = (data) => {
        userRole.scope === Scope.Restaurant && delete data.showInReport;
        dispatch(editTag(
            {
                id: tags._id,
                ...userRole,
                data
            }
        ));
    }

    const formCancelHandler = () => {
        navigator(`../../?page=${currentPage}&limit=${limit}`);
    }
    const schema = tagSchema();
    userRole.scope === Scope.Restaurant && delete schema.showInReport;

    const initialData = getFormData(tags);

    return (
        <>
            <SubHeader title="Update Tag">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-12 col-lg-8 col-xl-4">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form onFormSubmit={formSubmitHandler}
                                  onFormCancel={formCancelHandler}
                                  schema={schema}
                                  inline={false}
                                  initialData={initialData}
                                  status={editStatus}
                                  error={error}/>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default TagEdit;
